import { createSlice } from '@reduxjs/toolkit'
import { getOrganizations } from './organizationActions'

const initialState = {
  loading: false,
  error: null,
  success: false,
}

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrganizations.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getOrganizations.fulfilled, (state, { payload }) => {
        state.loading = false
        state.userInfo = payload
        state.userToken = payload.userToken
      })
      .addCase(getOrganizations.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload
      });
  },
})
export default organizationSlice.reducer